/** Rows shown per page in transaction history UIs. */
export const TRANSACTION_HISTORY_PAGE_SIZE = 5;

/** @deprecated Use TRANSACTION_HISTORY_PAGE_SIZE */
export const BUSINESS_SUITE_TRANSACTION_HISTORY_PAGE_SIZE =
  TRANSACTION_HISTORY_PAGE_SIZE;

/** API page size when over-fetching to fill a display page after client filters. */
export const TRANSACTION_HISTORY_API_BATCH_SIZE = 20;

export const TRANSACTION_HISTORY_FETCH_LIMIT = 100;
